export enum DatabaseCollection {
  CONFIGS = "configs",
  PROMO_CODES = "promo-codes",
  USERS = "users",
  PRODUCTS = "products",
  CUSTOMERS = "customers",
  EVENTS = "events",
  DEALS = "deals",
  TEMPORARY_DEALS = "temporary-deals",
  CUSTOMER_METRICS = "customer-metrics",
  AUDIT_LOGS = "audit-logs",
}
